import { createContext } from "react";
import type { Item } from "~/types/api";
import type { TabWindow, TabWindowState, DirectionType, AddWindowProps } from "../../task.types";

export type TabWindowsState<T> = {
  windows: TabWindow<T>[];
  sortedWindows: TabWindow<T>[];
  activeWindows: TabWindow<T>[];
  minimizedWindows: TabWindowState[];
  detailViewItem: Item[] | null;
  activePanelWindowId: string | null;
  isLoadingDetailView: boolean;
  isInitializing: boolean;
};

export type AddWindowOptions = AddWindowProps & {
  insertAfterWindowId?: string;
};

export type TabWindowsActions<T> = {
  updateItems: (items: T[], predicate?: (window: TabWindow<T>) => boolean) => void;
  addWindow: (items: T[], windowId?: string, title?: string, options?: AddWindowOptions) => void;
  closeWindow: (windowId: string) => void;
  updateWindowState: (windowId: string, newState: TabWindowState) => void;
  changeWindowOrder: (windowId: string, direction: DirectionType) => void;
  maximizeWindow: (windowId: string) => void;
  handleItemSelection: (
    windowId: string,
    itemId: number | Set<number>,
    multiSelect: boolean,
    fetchFresh?: boolean
  ) => void;
  togglePanelForWindow: (windowId: string) => void;
  togglePin: (windowId: string, isPinned: boolean) => void;
  openDetailView: (item: Item | Item[]) => void;
  closeDetailView: () => void;
  getWindow: (windowId: string) => TabWindow<T> | undefined;
  updateDetailViewForWindow: (
    windowId: string,
    newSelectedItems?: Set<number>,
    fetchFresh?: boolean
  ) => Promise<void>;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TabWindowsStateContext = createContext<TabWindowsState<any> | undefined>(undefined);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TabWindowsActionsContext = createContext<TabWindowsActions<any> | undefined>(
  undefined
);
